import instance from 'axios'
import qs from 'qs'

instance.defaults.paramsSerializer = (params) => {
  return qs.stringify(params)
}

export let axios = instance



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/services/axios.js